import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import ClientEditPerson from "./editPerson.vue";
import ClientEditCompany from "./clientEditCompany.vue";

import EditOwner from "@/views/Owner/edit.js";

export default {
    name: "Person",

    extends: EditOwner,

    props: ["clickedNext", "currentStep"],

    mixins: [validationMixin],

    components: { ClientEditPerson, ClientEditCompany },

    data: () => {
        return {};
    },

    methods: {
        validate: function() {
            if (this.owner.OwnerType == 0)
                return this.$refs.clientEditPerson.validate();

            if (this.owner.OwnerType == 1)
                return this.$refs.editCompany.validate();
        }


    }
};
